/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrdineDettaglioDTO
 */
export interface OrdineDettaglioDTO {
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioDTO
     */
    idOrdine?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioDTO
     */
    idDettaglio?: number;
    /**
     * 
     * @type {Date}
     * @memberof OrdineDettaglioDTO
     */
    dataConsegna?: Date;
    /**
     * 
     * @type {string}
     * @memberof OrdineDettaglioDTO
     */
    codiceProdotto?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrdineDettaglioDTO
     */
    descrizioneProdotto?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioDTO
     */
    quantita?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioDTO
     */
    prezzo?: number;
    /**
     * 
     * @type {number}
     * @memberof OrdineDettaglioDTO
     */
    riga?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrdineDettaglioDTO
     */
    richiesta?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrdineDettaglioDTO
     */
    recordModificabile?: boolean;
}

/**
 * Check if a given object implements the OrdineDettaglioDTO interface.
 */
export function instanceOfOrdineDettaglioDTO(value: object): value is OrdineDettaglioDTO {
    return true;
}

export function OrdineDettaglioDTOFromJSON(json: any): OrdineDettaglioDTO {
    return OrdineDettaglioDTOFromJSONTyped(json, false);
}

export function OrdineDettaglioDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrdineDettaglioDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'idOrdine': json['idOrdine'] == null ? undefined : json['idOrdine'],
        'idDettaglio': json['idDettaglio'] == null ? undefined : json['idDettaglio'],
        'dataConsegna': json['dataConsegna'] == null ? undefined : (new Date(json['dataConsegna'])),
        'codiceProdotto': json['codiceProdotto'] == null ? undefined : json['codiceProdotto'],
        'descrizioneProdotto': json['descrizioneProdotto'] == null ? undefined : json['descrizioneProdotto'],
        'quantita': json['quantita'] == null ? undefined : json['quantita'],
        'prezzo': json['prezzo'] == null ? undefined : json['prezzo'],
        'riga': json['riga'] == null ? undefined : json['riga'],
        'richiesta': json['richiesta'] == null ? undefined : json['richiesta'],
        'recordModificabile': json['recordModificabile'] == null ? undefined : json['recordModificabile'],
    };
}

  export function OrdineDettaglioDTOToJSON(json: any): OrdineDettaglioDTO {
      return OrdineDettaglioDTOToJSONTyped(json, false);
  }

  export function OrdineDettaglioDTOToJSONTyped(value?: OrdineDettaglioDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idOrdine': value['idOrdine'],
        'idDettaglio': value['idDettaglio'],
        'dataConsegna': value['dataConsegna'] == null ? undefined : ((value['dataConsegna']).toISOString()),
        'codiceProdotto': value['codiceProdotto'],
        'descrizioneProdotto': value['descrizioneProdotto'],
        'quantita': value['quantita'],
        'prezzo': value['prezzo'],
        'riga': value['riga'],
        'richiesta': value['richiesta'],
        'recordModificabile': value['recordModificabile'],
    };
}

